export enum LOG_TYPE {
  SESSION_START,
  SESSION_COMPLETE,
  USER_INTERACTION,
  DATA_CAPTURE,
  VEND_SUCCESS,
  VEND_ERROR,
  INVENTORY_ERROR,
  QR_ERROR,
  DEVICE_ERROR,
  DEVICE_LOG,
  SERIALPORT_COMMUNICATION,
}

export type LOG = {
  dateCreated: string;
  message: string;
  type: LOG_TYPE;
  experienceId?: string | null;
  serialNumber: string;
};
